module.exports = "<div class=\"row\">\n  <div class=\"col-sm-10\">\n    <app-shopping-edit></app-shopping-edit>\n    <hr/>\n    <ul class=\"list-group\">\n      <a class=\"list-group-item\" style=\"cursor: pointer\"\n        *ngFor=\"let ingredient of ingredients\"\n      >\n      {{ingredient.name}} ({{ ingredient.amount}})\n      </a>\n    </ul>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shopping-list/shopping-list.component.html
// module id = 161
// module chunks = 1